import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { DslService, Logger, OnFeatureInit } from '@frontend/vanilla/core';
import { firstValueFrom } from 'rxjs';
import { filter, first } from 'rxjs/operators';

import { DomainSpecificActionsConfig } from './domain-specific-actions.client-config';

@Injectable()
export class DomainSpecificActionsBootstrapService implements OnFeatureInit {
    private config = inject(DomainSpecificActionsConfig);
    private readonly router = inject(Router);
    private dslService = inject(DslService);
    private log = inject(Logger);

    async onFeatureInit() {
        await firstValueFrom(this.config.whenReady);

        this.router.events
            .pipe(
                filter((e) => e instanceof NavigationEnd),
                first(),
            )
            .subscribe(() => {
                if (this.config.dslAction) {
                    this.log.debug('Registering domain specific actions for the execution.');
                    this.dslService
                        .executeAction(this.config.dslAction)
                        .subscribe(() => this.log.debug(`${this.config.dslAction} domain specific actions executed.`));
                } else {
                    this.log.debug('No domain specific action to be executed.');
                }
            });
    }
}
